import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../../../global-components/global-components.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {LoginControllerComponent} from './login-controller.component';
import {RouterModule} from '@angular/router';

import {LoginFrameComponent} from './components/login-frame/login-frame.component';
import {LoginInputComponent} from './components/login-input/login-input.component';
import {LoginParentComponent} from './components/login-parent/login-parent.component';

@NgModule({
    declarations: [
        LoginControllerComponent,
        LoginFrameComponent,
        LoginInputComponent,
        LoginParentComponent
    ],
    exports: [
        LoginControllerComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        GlobalComponentsModule,
        SharedComponentsModule,
    ]
})
export class LoginModule {}
